import reframe from 'reframe.js';

document.addEventListener('DOMContentLoaded', () => {
  const iframes = document.getElementsByTagName('iframe');

  // Makes all iframes responsive
  if (iframes.length > 0) {
    reframe('#content iframe:not(.no-reframe)');
  }
});
